var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":false,"large":_vm.large,"extraLarge":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Athugasemdir nemanda")]),(_vm.studentId)?_c('StudentInfo',{staticStyle:{"margin-bottom":"-10px"},attrs:{"id":_vm.studentId}}):_vm._e(),_c('StudentComments',{attrs:{"studentId":_vm.studentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }